import React from 'react';
import { get, post, put, del, patch } from '../../Utility/Http';
import { supportUserListGet, hotelListGet, supportCreatePost, supportCreateUpdate, assignBusinessListGet, auditHistoryListGet, supportUserUpdateGet, branchListGet } from '../Model/SupportUserModel';
import Config from '../../../Utility/Config';

export const supportUserList = async (data) => {
    const response = await get(`${Config.extendedUrl}admin/users/list`, data);
    return supportUserListGet(response);
};
export const hotelList = async (data) => {
    const response = await get(`${Config.extendedUrl}organisation`, data);
    return hotelListGet(response);
};
export const supportCreate = async (data, id, type) => {
    if (type == 'post') {
        const response = await post(`${Config.extendedUrl}admin/users`, data);
        return supportCreatePost(response);
    } else {
        const response_1 = await patch(`${Config.extendedUrl}admin/users/${id}`, data);
        return supportCreateUpdate(response_1);
    }
};

export const assignBusinessList = async (data, id) => {
    const response = await get(`${Config.extendedUrl}users/user_details/${id}`, data);
    return assignBusinessListGet(response);
};

export const auditHistoryList = async (data, id) => {
    const response = await get(`${Config.extendedUrl}audit/history`, data);
    return auditHistoryListGet(response);
};
export const supportUserUpdate = async (data, id) => {
    const response = await patch(`${Config.extendedUrl}admin/users/${id}`, data);
    return supportUserUpdateGet(response);
};

// export const branchListApi = async (data, version = 'v3.0.1') => {
//     const response = await get(`${Config.extendedUrl}${version}/org_branch`, data);
//     return branchListGet(response);
// };

export const branchListApi = async (data, version = 'v3.0.1') => {
    const userVersion = data?.userCredentials?.user_details.version;

    if (["v3.0.1", "v4", "v5", "v6"].includes(userVersion)) {
        version = userVersion;
    }

    const response = await get(`${Config.extendedUrl}${version}/org_branch`, data);
    return branchListGet(response);
};


